import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/ga4';

const GA4PageTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on every route change
    const path = location.pathname + location.search;
    const title = document.title;
    const lang = document.documentElement.lang || 'el';

    trackPageView(path, title, lang);
    window.metaPixelTrackPageView?.(path, title);
  }, [location]);

  return null;
};

export default GA4PageTracker;
